<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-btn
      fixed
      fab
      bottom
      right
      color="primary"
      slot="activator"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Neues Mitglied erstellen</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex sm6>
              <v-text-field
                label="Unternehmensbezeichnung"
                required
                v-model="member.title"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field label="Logo" @click='pickFile' v-model='imageName' prepend-icon='attach_file'>
              </v-text-field>
              <v-img
                v-if="imageUrl"
                :src="imageUrl"
                height="150"
                contain></v-img>
              <input type="file" @change="showThumbnail" ref="pictureInput" style="display: none" accept="image/*"/>
            </v-flex>
            <v-flex sm6>
              <v-select
                :items="items"
                label="Branche"
                item-text="title"
                item-value="id"
                v-model="member.branch"
              ></v-select>
            </v-flex>
            <v-flex sm6>
              <v-select
                :items="items"
                label="Branche#2"
                item-text="title"
                item-value="id"
                v-model="member.branch2"
              ></v-select>
            </v-flex>
            <v-flex sm12>
              <v-text-field
                label="Web Adresse"
                required
                v-model="member.web"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field
                label="Email"
                v-model="member.email"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field
                label="Telefonnummer"
                v-model="member.phone"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field
                label="Adresse"
                v-model="member.address"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-textarea
                label="Öffnungszeiten"
                v-model="member.openingTimes"
                :disabled="loading"></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
        <small>* Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="save()" :loading="loading">Erstellen</v-btn>
        <v-btn color="error" @click.native="dialog = false; member = {}">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'DlgMemberNew',
  components: {
  },
  data() {
    return {
      dialog: false,
      member: {},
      loading: false,
      items: [],
      imageUrl: null,
      imageName: null,
    };
  },
  computed: {
    ...mapGetters({
      branches: 'branch/all',
    }),
  },
  methods: {
    ...mapActions({
      memberCreate: 'member/create',
      memberRead: 'member/read',
      branchRead: 'branch/read',
    }),
    save() {
      this.loading = true;
      this.memberCreate({ user: this.member, image: this.$refs.pictureInput.files[0] }).then((res) => {
        this.loading = false;
        if (res) {
          this.memberRead();
          this.member = {};
          this.imageUrl = null;
          this.imageName = null;
          this.dialog = false;
        }
      });
    },
    onChange() {
    },
    showThumbnail() {
      this.imageUrl = URL.createObjectURL(this.$refs.pictureInput.files[0]);
      this.imageName = this.$refs.pictureInput.files[0].name;
    },
    pickFile() {
      this.$refs.pictureInput.click();
    },
  },
  mounted() {
    this.loading = true;
    this.branchRead().then(() => {
      this.loading = false;
      this.items = this.branches;
    });
    this.member.password = `${Math.random().toString(36).substr(2, 9)}`;
  },
};
</script>

<style scoped>

</style>
